import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { PaginatedResponse, Product } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'
import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}

export class Products {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Product> => {
    const response = await this.api.get(`/logistics/products/${guid}`, config)
    return rawTransform(Product)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Product>> => {
    const response = await this.api.get('/logistics/products', config)
    return paginatedTransform(Product)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Product> => {
    const response = await this.api.post('/logistics/products', data, config)
    return rawTransform(Product)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Product> => {
    const response = await this.api.patch(`/logistics/products/${guid}`, data, config)
    return rawTransform(Product)(response.data)
  }

  export = async ({ fields }: ExportProps ) => {
    const params = { fields: fields.join(',')}
    const response = await this.api.axiosInstance({
      url: '/logistics/products/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'places.csv')
  }
}
